import React, { Fragment, useState } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import FormInput from "../../form-input/form-input.component";
import { connect } from "react-redux";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { addSubCategory } from "../../../actions/subCategory.action";
import "../bootstrap.css";
import { setAlert } from "../../../actions/alert";

const AddSubCategory = ({ addSubCategory, setAlert , categories }) => {
  const [addModals, setShow] = useState(false);
  const [adv, setAdv] = useState({
    title: "",
    description: "",
    url :"",
    category :"",
    sortBy :""
  });

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const { title, description , url , category ,sortBy } = adv;



  const onChange = (e) => {
    setAdv({ ...adv, [e.target.name]: e.target.value });
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    if (title === "" || description === "" || category === "") {
      setAlert("ارجو تعبئة كل الحقول و تحميل الصور لهدا القسم الفرعي", "danger");
    } else {
      addSubCategory(title, description ,url , category,sortBy);
      setAdv({
        title: "",
        description: "",
        url:"",
        category : "",
        sortBy :""
      });
      setAlert("تمت إضافة القسم الفرعي بنجاح", "success");
      setShow(false);
    }
  };

  return (
    <Fragment>
      <a
        href="#!"
        onClick={handleShow}
        className=" btn-outline btn-block btn-radius lead"
      >
        {" "}
        <FontAwesomeIcon icon={faPlus} />{" "}
      </a>
      <Modal show={addModals} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title> إضافة قسم فرعي </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={onSubmit}>
            
            <FormInput
              name="title"
              type="text"
              handleChange={onChange}
              value={title}
              label="عنوان القسم الفرعي"
              required
            />
              <FormInput
              name="sortBy"
              type="number"
              handleChange={onChange}
              value={sortBy}
              label="الترتيب"
              required
            />
             <FormInput
              name="url"
              type="text"
              handleChange={onChange}
              value={url}
              label="رمز القسم الفرعي"
              required
            />
            <label for="dep">اختر القسم</label>
            <select
              type="text"
              name="category"
              value={category}
              onChange={onChange}
              label="القسم"
              required
              id="dep"
            >
              <option value=""> الاقسام</option>
              {categories&& categories.map(category => 
              <option value={category._id}  > {category.title}</option> )
              }
              
             
            </select>

            <label htmlFor="firstName" className="active">
              عن 
            </label>
            <CKEditor
              editor={ClassicEditor}
              data={description}
              onChange={(event, editor) => {
                const data = editor.getData();
                setAdv({ ...adv, description: data });
              }}
            />
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-dark btn-block"
            type="submit"
            onClick={onSubmit}
          >
            {" "}
            إضافة{" "}
          </button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default connect(null, {
  addSubCategory,
  setAlert,
})(AddSubCategory);
